export const AccountsLayout = ({ children }) => {
  return (
    <div className='flex md:min-h-[900px] bg-gradient-to-r from-[rgba(204,224,221,0.40)] from-[4.61%] via-[rgba(159,183,215,0.40)] via-[60.06%] to-[rgba(190,190,223,0.40)] to-[105.43%] p-[20px] md:p-[80px_30px] '>
      {children}
    </div>
  )
}
